import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { isBrowser } from '@app/utils/isBrowser'

export function scrollToTop() {
  isBrowser && window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
}

export const ScrollToTop = () => {
  const { pathname } = useLocation()
  useEffect(scrollToTop, [pathname])
  return null
}
